import { GET_PROFILE_REPORT } from 'govbr.frontend.policy/constants/ActionTypes';
import { GET_PROFILE_REPORT_CSV } from 'govbr.frontend.policy/constants/ActionTypes';

/**
 * Action para buscar o relatório de perfis.
 *
 * Esta action:
 * - Consome o endpoint /@profile-report
 * - Delega paginação, ordenação e filtros ao backend
 * - Mantém o front apenas como consumidor de páginas
 *
 * @param {number} page      - Página atual (1-based, padrão = 1)
 * @param {number} pageSize  - Quantidade de itens por página
 * @param {Array}  roles     - Lista de roles para filtro
 *
 * @returns {Object} Redux action no padrão Volto (request-based)
 */
export function getProfileReport(page = 1, pageSize = 30, roles = []) {
  // Monta os parâmetros de roles no formato:
  // roles=Editor&roles=Reviewer
  const rolesQuery = roles
    .map((r) => `roles=${encodeURIComponent(r)}`)
    .join('&');

  // Query base (page e page_size são sempre enviados)
  const query = [`page=${page}`, `page_size=${pageSize}`, rolesQuery]
    .filter(Boolean)
    .join('&');

  return {
    type: GET_PROFILE_REPORT,
    request: {
      op: 'get',
      path: `/@profile-report?${query}`,
    },
  };
}

/**
 * Action para buscar o relatório de perfis.
 *
 * Esta action:
 * - Consome o endpoint /@profile-report
 * - Usa paginacao fixa para exportacao em CSV

 *
 * @param {number} page      - Página atual (1-based, padrão = 1)
 * @param {number} pageSize  - Quantidade de itens por página
 * @param {Array}  roles     - Lista de roles para filtro
 *
 * @returns {Object} Redux action no padrão Volto (request-based)
 */
export function getProfileReportCsv(roles = []) {
  // Monta os parâmetros de roles no formato:
  // roles=Editor&roles=Reviewer
  const rolesQuery = roles
    .map((r) => `roles=${encodeURIComponent(r)}`)
    .join('&');

  // Query base (page e page_size são sempre enviados)
  const query = [`page=${1}`, `page_size=all`, rolesQuery]
    .filter(Boolean)
    .join('&');

  return {
    type: GET_PROFILE_REPORT_CSV,
    request: {
      op: 'get',
      path: `/@profile-report?${query}`,
    },
  };
}
